import React from 'react';
import { useSelector } from 'react-redux';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { useGetRoomLabels } from 'components/Offer/hooks/useGetRoomLabels';
import { SearchOffer } from 'modules/sapiSearch/slice';
import { getShouldShowYourChoiceTag } from 'modules/search/selectors';
import { Box } from '@daedalus/atlas/helpers/Box';
import { Text } from '@daedalus/atlas/Text';
const _exp = /*#__PURE__*/() => Text;
const TextContainer = /*#__PURE__*/styled(_exp())({
  name: "TextContainer",
  class: "t1046njt",
  propsAsIs: true
});
interface Props {
  offer: SearchOffer;
}
// Added as a part of 70766997-desktop-hotel-card-secondary-offers
export const RoomLabelsText: React.FC<Props> = ({
  offer
}) => {
  const shouldShowYourChoice = useSelector(getShouldShowYourChoiceTag(offer));
  const translatedLabels = useGetRoomLabels({
    offer
  });
  const isSingleYourChoiceLabel = shouldShowYourChoice && translatedLabels.length === 1;
  const fullText = translatedLabels.join(' \u00B7 ');
  const otherLabels = shouldShowYourChoice ? [...translatedLabels].splice(1, 1).join(' \u00B7 ') : translatedLabels.join(' \u00B7 ');
  if (translatedLabels.length <= 0) return null;
  return <Box display="flex" alignItems="center" title={fullText}>
      {shouldShowYourChoice && <TextContainer dataId="RoomLabels" variant="bodyXS" className={cx('__hasFirstGreen', isSingleYourChoiceLabel && '__showTruncated')}>
          {translatedLabels[0]}
          {translatedLabels.length > 1 && ' \u00B7 '}
        </TextContainer>}
      {!isSingleYourChoiceLabel && <TextContainer colorPath="content.neutral.c600" variant="bodyXS" dataId="RoomLabels">
          {otherLabels}
        </TextContainer>}
    </Box>;
};

require("./RoomLabelsText.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./RoomLabelsText.tsx");